import { createAsyncThunk } from "@reduxjs/toolkit";
import { createGenericSlice } from "../createGenericSlice";
import ApiManager from "../../api/ApiManager";

export const fetchLanding = createAsyncThunk('landing', () => ApiManager.fetchLanding())

type LandingContentType = {
    [panelType: string]: {
        categoryId: number
        productsQuantity: number
        products: {
            img: string
            name: string
            price: number
            unit: string
        }[]
    }[]
}

const initialState = {}

const landingSlice = createGenericSlice<LandingContentType>({
    name: 'landing',
    initialState: initialState,
    asyncThunk: fetchLanding
})

export default landingSlice.reducer;